const SET_FRONT = "SET_FRONT";
const SET_MODE = "SET_MODE";
const SET_AUTO = "SET_AUTO";
const SET_SPINNER = "SET_SPINNER";
const SET_CROSSHAIR = "SET_CROSSHAIR";
const SET_SLIDER_POINT = "SET_SLIDER_POINT";
const SET_IS_DETECTING = "SET_IS_DETECTING";
const HIDE_AUTO = "HIDE_AUTO";

import { getField, updateField } from "vuex-map-fields";

const option = {
    false: "environment",
    true: "user"
}


export default {
  namespaced: true,
  state: {
    mode: "environment",
    front: false,
    auto: false,
    spinner: false,
    sliderPoint: 3,
    focus: true,
    showImageFromCloud: false,
    isDetecting: false,
  },
  actions: {
    switchMode({ commit, state }) {
        commit(SET_MODE, option[!state.front]);
        commit(SET_FRONT, !state.front);
    },

    switchAuto({ commit, state }) {
        commit(SET_AUTO, !state.auto);
    },

    hideAuto({commit},payload) {
      commit(HIDE_AUTO, payload);
    },

    toggleCrosshair({ commit, state }) { 
        commit(SET_CROSSHAIR, !state.focus);
    },

    setSpinner({ commit }, payload) { 
        commit(SET_SPINNER, payload);
    },

    setSliderPoint({ commit }, payload) { 
        commit(SET_SLIDER_POINT, payload);
    },

    setIsDetecting({ commit }, payload) { 
        commit(SET_IS_DETECTING, payload);
    }
  },
  mutations: {
    updateField,

    SET_FRONT(state, payload) {
      state.front = payload;
    },

    SET_AUTO(state, payload) {
        state.auto = payload;
    },

    SET_MODE(state, payload) {
        state.mode = payload;
    },

    SET_SPINNER(state, payload) { 
        state.spinner = payload;
    },

    SET_CROSSHAIR(state, payload) { 
        state.focus = payload;
    },

    SET_SLIDER_POINT(state, payload) { 
        state.sliderPoint = payload;
    },

    HIDE_AUTO(state, payload) {
      state.auto = payload;
    },

    SHOW_IMAGE_FROM_CLOUD(state, payload) {
      state.showImageFromCloud = payload;
    },

    SET_IS_DETECTING(state, payload) { 
      state.isDetecting = payload;
  },
  },
  getters: {
    getField,
  },
  setters: {
    getField,
  },
};
